<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Electrical Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Electrical Engineering'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="flex justify-center">
            <div class="flex flex-col space-y-1 items-center">
              <img class="shadow-lg" :src="`/static/images/electrical/faculty/Tarpe_P_C.jpg`"
                   alt="Head of Department of Electrical Engineering">
              <h3 class="text-lg font-bold text-gray-800 leading-tight">Dr. Tarpe P. C.</h3>
              <h4 class="text-gray-600 leading-tight">Head of the Department & Associate Professor</h4>
            </div>
          </div>
          <blockquote class="mt-3 text-gray-600 text-justify font-medium">
            <p>Electrical Engineering was introduced in the year 2006 at our esteemed institution, SND College of
              Engineering & Research Centre, Yeola (Nashik) (M.S.) with a key objective and aim of providing both
              fundamentals and Industry/ Future ready programs in this field by nurturing the students to deep-dive in
              their fields of interest and also motivating them to excel. </p>
            <p>Today, the role of a department is not only to pursue academic excellence but also to motivate and
              empower its students to be lifelong learners, critical thinkers, and productive members of an
              ever-changing global society.</p>
            <p>In this direction, the department provides an excellent environment for its students and faculties to
              work with zeal and enthusiasm with an aim to give their best. The department also provides facilities to
              carry out research in the emerging technology areas.</p>
            <p>With the ever growing demand of Electrical Engineers in all sectors, the Electrical Engineering
              Department is making best efforts to give the society highly knowledgeable, trained and capable
              engineers who have hands on experience and would be ready to face challenges of the real world. Our
              Department consists of various laboratories like Basic Electrical Engineering, Power Electronics and
              Drives , Machines, Protection, High Voltage, Power Quality equipped with the new technological set ups
              giving the scope to all students having a hands on experience individually, which will increase their
              confidence to face the practical problems in the field of Electrical Engineering.</p>
            <p>The department conducts various programs under the departmental association called as Electrical
              Engineering Students Association (EESA) such as Workshops, Technical Training, Guest Lectures and
              Seminar by Experts from Industry and Academic background for constant knowledge up-gradation of staff
              and students. This activity helps to know the latest technologies, in the field of Electrical
              Engineering.</p>
            <p>The focus of the department is to imbibe the students with a potential through a broad exposure to all
              aspects that facilitates them for all round development. The department has a dedicated team of
              faculties with a wide spectrum of specialization such as Power Systems. The course has a healthy blend
              of Power Engineering, Electronics and Computer Engineering. The course pattern is planned to keep the
              students up-to-date with recent trends by organizing regular trainings, e-learning , industrial visits,
              workshops, conferences, faculty development programs, etc. The students are provided a platform to
              think, express, and exhibit their skills.</p>
            <p>The commitment and passion for learning and teaching by the students as well as faculties will
              definitely lead our future budding engineers to be industry ready. Education is a shared commitment
              between dedicated teachers, motivated students and enthusiastic parents with high expectations.</p>
            <p>I am extremely happy to be associated with this department, one of the core and oldest branch of
              Engineering that is and now including the applications of Electronics for controlling Electrical Devices
              and renamed as Electrical and Electronics Engineering. I thank our management, researchers, teachers,
              alumni and students for their continuous support and cooperation.</p>
            <p>We continue to play a leading role in our discipline which leads us towards creating innovative and
              effective professional graduate community which would vivacious and provide continuous learning. I
              extend my warm wishes to all budding Electrical Engineers.</p>
            <signature name="Dr. Tarpe P. C." designation="Head of the Department"></signature>
          </blockquote>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/electrical/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import Signature from "@/components/Signature";

export default {
  name: "About",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    Signature,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {div: null}
  }
}
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0.6rem;
}
</style>
